import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  selectSnackbars,
  removeSnackbar,
  selectModal,
  hideModal,
} from "../../../state/snackbar/snackbarSlice";
import AlertModal from "../AlertModal/AlertModal";
import { Snackbar, Alert, Box, useTheme, useMediaQuery } from "@mui/material";

export const SnackbarProvider = ({ children }) => {
  const dispatch = useDispatch();
  const snackbars = useSelector(selectSnackbars);
  const modal = useSelector(selectModal);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const drawerWidth = isMobile ? 75 : 220;

  const handleCloseSnackbar = (id) => (event, reason) => {
    if (reason === "clickaway") return;
    dispatch(removeSnackbar(id));
  };

  const handleCloseModal = () => {
    dispatch(hideModal());
  };

  return (
    <>
      {children}
      {/* Snackbars */}
      <Box
        sx={{
          position: "fixed",
          bottom: 24,
          left: drawerWidth,
          zIndex: (theme) => theme.zIndex.snackbar,
          display: "flex",
          flexDirection: "column-reverse",
          gap: 3,
        }}
      >
        {snackbars.map((snackbar) => (
          <Snackbar
            key={snackbar.id}
            open={true}
            autoHideDuration={snackbar.duration}
            onClose={handleCloseSnackbar(snackbar.id)}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            sx={{ position: "relative", marginBottom: "-20px" }}
          >
            <Alert
              onClose={handleCloseSnackbar(snackbar.id)}
              severity={snackbar.severity}
              sx={{ width: "100%" }}
            >
              {snackbar.message}
            </Alert>
          </Snackbar>
        ))}
      </Box>

      {/* Modal */}
      <AlertModal
        open={modal.open}
        onClose={handleCloseModal}
        message={modal.message}
        severity={modal.severity}
      />
    </>
  );
};
